import { closeCurrentWebView } from "@/utils/native/interaction";

export default [
  {
    path: "/wt-promotion-list",
    name: "PromotionList",
    meta: {
      title: "限时秒杀",
      keepAlive: false,
      imgHeader: require("@/assets/img/promotion/promotion-header.png"),
      showHeader: true
    },
    component: () =>
      import(
        /* webpackChunkName: "promotion" */ "../views/promotion/PromotionList.vue"
      )
  },
  {
    path: "/wt-promotion-detail/:code",
    name: "PromotionDetail",
    meta: { title: "详情", showHeader: false, background: "#FFCF00" }, // theme: "dark",
    component: () =>
      import(
        /* webpackChunkName: "promotion" */ "../views/promotion/PromotionDetail.vue"
      )
  },
  {
    path: "/wt-promotion-confirm",
    name: "PromotionConfirm",
    meta: { title: "确认订单", theme: "dark", showHeader: true },
    component: () =>
      import(
        /* webpackChunkName: "promotion" */ "../views/promotion/PromotionConfirm.vue"
      )
  },
  {
    path: "/wt-promotion-success",
    name: "PromotionSuccess",
    meta: {
      title: "提交成功",
      showHeader: true,
      customBackFn: closeCurrentWebView
    },
    component: () =>
      import(
        /* webpackChunkName: "promotion" */ "../views/promotion/PromotionSuccess.vue"
      )
  }
];
